import { addReducer } from "incremental-redux-reducers";

export default addReducer(
  "locationAggregateRisk",
  function locationAggregateRiskReducer(state = {}, action) {
    switch (action.type) {
      case "LOCATION_AGGREGATE_RISK_LOAD":
        let { locationId, aggregates } = action;

        return {
          ...state,
          [locationId]: aggregates
        };
      default:
        return state;
    }
  }
);
